var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2813 11.8513V10.8819C23.2813 5.562 19.1233 1.25 14.0001 1.25C8.87684 1.25 4.71884 5.562 4.71884 10.8819V11.8513C4.72049 13.0084 4.39027 14.1417 3.76734 15.1169L2.24384 17.4888C0.85371 19.6544 1.91521 22.5983 4.33384 23.283C10.6535 25.0746 17.3467 25.0746 23.6663 23.283C26.085 22.5983 27.1465 19.6544 25.7563 17.4901L24.2328 15.1183C23.6094 14.1432 23.2787 13.0099 23.28 11.8526L23.2813 11.8513Z",
    stroke: "#8B9373",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 24.625C8.71312 27.0285 11.1427 28.75 14 28.75C16.8573 28.75 19.2869 27.0285 20.1875 24.625",
    stroke: "#8B9373",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.94cab67997c8c0c025088b2e91c37700.svg";
export { ForwardRef as ReactComponent };